module.exports = __webpack_public_path__ + "static/media/file12.e5180fa4.jpg";